import { TYPE_QUESTIONS, removeAccentsAndConvertLowercase, areTextsEqual } from "@educaplay/core";
import { QUESTION_TYPE } from "./constants";


export function validateTextQuestion({ sortedAnswered, correctAnswers, isCaseSensitive }) {
    if (!sortedAnswered) return false;
    if (isCaseSensitive) {
        //Si es sensible a Mayusculas y Acentos
        return correctAnswers.some((correctAnswer) => {
            return areTextsEqual(sortedAnswered, correctAnswer);
        })
    }

    //No es sensible a Mayusculas y Acentos
    const formattedAnswer = removeAccentsAndConvertLowercase(sortedAnswered);
    for (let i = 0; i < correctAnswers.length; i++) {
        const formattedCorrectAnswer = removeAccentsAndConvertLowercase(correctAnswers[i]);
        if (areTextsEqual(formattedAnswer, formattedCorrectAnswer)) {
            return true
        }
    }
    return false;
}

export function validateSingleQuestion({ sortedAnswered, correctAnswers }) {

    return correctAnswers.includes(sortedAnswered);
}

export function validateMultiQuestions({ sortedAnswered, correctAnswers }) {
    if (sortedAnswered.length !== correctAnswers.length) return false;
    return correctAnswers.every((entry, index) => entry === sortedAnswered[index]);
}

export function countAnswers({ sortedAnswered, correctAnswers, numberQuestions }) {
    if (!sortedAnswered || sortedAnswered.length === 0) {
        return { correct: 0, incorrect: numberQuestions };
    }

    const correctCount = sortedAnswered.filter(answer => correctAnswers.includes(answer)).length;
    const incorrectCount = Math.max(correctAnswers.length - correctCount, sortedAnswered.length - correctCount);
    return { correct: correctCount, incorrect: incorrectCount };
}

export function calculateCasePoints({ sortedAnswered, correctAnswers, question, questionType, points, isCaseSensitive, penalty }) {
    switch (questionType) {

        case QUESTION_TYPE.MultiQuestion: {
            if (validateMultiQuestions({ sortedAnswered, correctAnswers })) return points;
            const numberQuestions = question.RESPUESTAS.length;
            const count = countAnswers({ sortedAnswered, correctAnswers, numberQuestions });
            const portionPoint = points / correctAnswers.length;
            const resultPoints = Math.max((portionPoint * count.correct) - (portionPoint * count.incorrect), 0);
            return resultPoints + penalty;
        }

        case QUESTION_TYPE.SingleQuestion: {
            if (validateSingleQuestion({ sortedAnswered, correctAnswers })) return points;
            return penalty;
        }

        case QUESTION_TYPE.TextQuestion: {
            if (validateTextQuestion({ sortedAnswered, correctAnswers, isCaseSensitive })) return points;
            return penalty;
        }

        default: {
            return 0;
        }

    }
}

export function checkTypeAnswer({ sortedAnswered, questionType, correctAnswers, isCaseSensitive }) {
    switch (questionType) {

        case TYPE_QUESTIONS.Selection: {
            if (Array.isArray(sortedAnswered)) {
                return validateMultiQuestions({ sortedAnswered, correctAnswers });
            }
            return validateSingleQuestion({ sortedAnswered, correctAnswers });
        }

        case TYPE_QUESTIONS.Text: {
            return validateTextQuestion({ sortedAnswered, correctAnswers, isCaseSensitive });
        }


        default: {
            return false;
        }

    }

}

export function getAlphabetLetter(index) {
    if (index >= 0 && index < 26) {
        const AsciiCodeA = 'A'.charCodeAt(0);
        const letter = String.fromCharCode(AsciiCodeA + index);
        return letter;
    }
}
